function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
var SvgWideAmp = function SvgWideAmp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    fill: "#F343AD",
    fillOpacity: 0.1,
    style: _defineProperty(_defineProperty({
      fill: "#F343AD"
    }, "fill", "color(display-p3 0.9529 0.2627 0.6784)"), "fillOpacity", 0.1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6669 11.483L18.0926 6.06202C18.7872 5.36801 19.1345 5.021 19.3772 5.00217C19.5864 4.98594 19.7901 5.06179 19.909 5.20023C20.0471 5.36092 19.9381 5.79668 19.72 6.66818L18.5014 11.5384L20.4879 11.3239C21.2019 11.2468 21.5589 11.2082 21.739 11.3025C21.8953 11.3842 21.9924 11.5214 21.9998 11.6706C22.0082 11.8426 21.7832 12.0674 21.3331 12.517L15.9074 17.938C15.2128 18.632 14.8655 18.979 14.6228 18.9978C14.4136 19.0141 14.2099 18.9382 14.091 18.7998C13.9529 18.6391 14.0619 18.2033 14.28 17.3318L15.4986 12.4616L13.5121 12.6761C12.7981 12.7532 12.4411 12.7918 12.261 12.6975C12.1047 12.6158 12.0076 12.4786 12.0002 12.3294C11.9918 12.1574 12.2168 11.9326 12.6669 11.483Z",
    fill: "url(#paint0_linear_2269_19068)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2269_19068",
    x1: 11.8029,
    y1: 18.7696,
    x2: 11.8029,
    y2: 5.23048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF",
    style: _defineProperty(_defineProperty({
      stopColor: "#0047FF"
    }, "stopColor", "color(display-p3 0.0000 0.2800 1.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419774,
    stopColor: "#DB00FF",
    style: _defineProperty(_defineProperty({
      stopColor: "#DB00FF"
    }, "stopColor", "color(display-p3 0.8600 0.0000 1.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFC700"
    }, "stopColor", "color(display-p3 1.0000 0.7800 0.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFC700"
    }, "stopColor", "color(display-p3 1.0000 0.7800 0.0000)"), "stopOpacity", 1)
  }))));
};
export default SvgWideAmp;